import { render, staticRenderFns } from "./oneClass.vue?vue&type=template&id=47b8fd34&scoped=true"
import script from "./oneClass.vue?vue&type=script&lang=js"
export * from "./oneClass.vue?vue&type=script&lang=js"
import style0 from "./oneClass.vue?vue&type=style&index=0&id=47b8fd34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8fd34",
  null
  
)

export default component.exports